export const BASE_URL = '/da';
export const SERVER_BASE_URL = 'https://www.onlylife.pro/da'; 